module.exports = __webpack_public_path__ + "static/media/ApexClearing_Logo_2Color_Blue.10c7669a.svg";